import { SplitFactory } from '@splitsoftware/splitio';
import Cookies from 'js-cookie';

import { getEnv } from '../components/Context/env';
import { SPLIT_CLIENT_FAILED, SPLIT_CLIENT_READY, SPLITS_FETCHED } from '../actions/split';
import isServer from '../helpers/isServer';
import mockSplit from '../helpers/test/mocks/split';
import { splitsList } from '../constants';

const featureFlags = Object.values(splitsList);
const emailAttributeEnvironments = new Set(['dev', 'int', 'stg', 'local']);

let splitInitialised = false;

export default (runningOnServer, env = getEnv(), defaultSplitApiKey = 'localhost') =>
  store =>
  next =>
  action => {
    const { split, subscriptions, auth } = store.getState();
    const familyRequested = subscriptions?.error || subscriptions?.fetched;
    const family = subscriptions?.current?.family;
    const customerEmail = auth?.currentUser?.email;
    const isFlexUser = store.getState().entitlementsApi?.queries?.['getIsFlexUser(undefined)']?.data?.isFlex;
    const customerCreatedDate = auth?.currentUser?.createDt;

    if (
      !split.key ||
      (!family && !familyRequested) ||
      isFlexUser === undefined ||
      split.ready ||
      split.error ||
      splitInitialised
    ) {
      return next(action);
    }

    const onServer = [true, false].includes(runningOnServer) ? runningOnServer : isServer();

    splitInitialised = [true, false].includes(split.initialised) ? split.initialised : true;

    const shouldUseLocalMode = onServer || env.REACT_APP_ENV === 'local' || window?.Cypress?.isIntegrationTest;
    const apiKey = shouldUseLocalMode ? defaultSplitApiKey : env.REACT_APP_SPLIT_API_KEY;

    const factory = SplitFactory({
      core: {
        authorizationKey: apiKey || defaultSplitApiKey,
        key: split.key,
      },
      features: mockSplit(split.key),
      startup: {
        readyTimeout: 5,
      },
    });

    const client = factory.client();

    client.on(client.Event.SDK_READY, () => {
      store.dispatch({
        type: SPLIT_CLIENT_READY,
      });

      const optimConsent = Cookies.get('EXPERIAN_ENSIGHTEN_PRIVACY_Performance_and_Analytics') === '1';
      const attributes = {
        customerNumber: split.key,
        family,
        optimConsent,
        isFlexUser,
      };

      if (customerCreatedDate) {
        attributes.customerCreatedDate = Date.parse(customerCreatedDate);
      }

      if (customerEmail && emailAttributeEnvironments.has(env.REACT_APP_ENV)) {
        attributes.email = customerEmail;
      }

      try {
        store.dispatch({
          type: SPLITS_FETCHED,
          payload: client.getTreatmentsWithConfig(featureFlags, attributes) || {},
        });
      } catch (e) {
        store.dispatch({
          type: SPLITS_FETCHED,
          payload: e,
        });
      }
    });

    client.on(client.Event.SDK_READY_TIMED_OUT, () => {
      store.dispatch({
        type: SPLIT_CLIENT_FAILED,
      });
    });

    return next(action);
  };
